export default __webpack_public_path__ + "static/media/search.7dd11b7b.svg";